import React from "react";
import { OrderProductListProps } from "../utils/types";
import CommonTable from "src/business-types/grocery/components/CommonTable";

interface ProductTableData {
  id: string | number;
  sno: number;
  name: string;
  car: string;
  qty: string | number;
  price: string | number;
}

const OrderProductList: React.FC<OrderProductListProps> = ({ order }) => {
  const tableData: ProductTableData[] = React.useMemo(() => {
    // Get products from orderDetails
    const orderDetails = order?.orderDetails?.[0];
    const products = orderDetails?.products || [];

    let globalIndex = 0;

    // Process products that have services
    return products.flatMap((product: any, productIndex: number) => {
      const services = product?.service || [];

      // If product has services, create rows for each service
      if (services.length > 0) {
        return services.map((service: any, serviceIndex: number) => {
          globalIndex += 1;
          return {
            id: `${productIndex}-${serviceIndex}`,
            sno: globalIndex,
            name: product?.name || product?.arabicName || "N/A",
            car: service?.carNumber || "N/A",
            qty: product.quantity || 1,
            price: product.lineTotal || product.unitPrice || 0,
          };
        });
      }
      // If product has no services, create a single row
      else {
        globalIndex += 1;
        return [{
          id: productIndex,
          sno: globalIndex,
          name: product?.name || product?.arabicName || "N/A",
          car: "N/A",
          qty: product.quantity || 1,
          price: product.lineTotal || product.unitPrice || 0,
        }];
      }
    });
  }, [order]);

  const headCells = [
    { id: "sno" as keyof ProductTableData, label: "S.No", align: "center" as const, sorting: false },
    { id: "name" as keyof ProductTableData, label: "Product Name", align: "left" as const, sorting: false },
    { id: "car" as keyof ProductTableData, label: "Car Numbers", align: "center" as const, sorting: false },
    { id: "qty" as keyof ProductTableData, label: "Quantity", align: "center" as const, sorting: false },
    { id: "price" as keyof ProductTableData, label: "Total (QAR)", align: "right" as const, sorting: false },
  ];

  return (
    <div className="order-product-container h-full flex flex-col">
      <CommonTable<ProductTableData>
        data={tableData}
        headCells={headCells}
        title="Order Products"
        selectable={false}
        denseToggle={false}
        showToolbar={false}
        pagenation={true}
        pageSize={5}
        showFilterIcon={false}
        Action={false}
        shortByTable={false}
        className="compact-table h-full"
      />
    </div>
  );
};

export default OrderProductList;